import React from 'react'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const Security = () => {
  const { formatMessage } = useIntl()
  return(
  <div className="mt-10 divide-y divide-gray-200">
    <div className="space-y-1">
      <h3 className="text-lg leading-6 font-medium text-gray-900">
        <FormattedMessage {...messages.security}/>
      </h3>
      <p className="max-w-2xl text-sm text-gray-500">
        <FormattedMessage {...messages.beCareful}/>
      </p>
    </div>
    <div className="mt-6">
      <dl className="divide-y divide-gray-200">
        <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
          <dt className="text-sm font-medium text-gray-500">
            <FormattedMessage {...messages.password}/>
          </dt>
          <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            <span className="grow" />
            <span className="ml-4 shrink-0">
              <a href="/system/forgotpassword" className="bg-white rounded-sm font-medium text-primary-darker hover:text-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
                <FormattedMessage {...messages.reset}/>
              </a>
            </span>
          </dd>
        </div>
      </dl>
    </div>
  </div>
)}

export default Security
